<template>
  <b-modal
    id="folder-modal"
    ref="folderModal"
    :title="isEdit ? 'Editar Carpeta' : 'Nueva Carpeta'"
    :visible="visible"
    hide-footer
    no-close-on-backdrop
    @hidden="$emit('close')"
  >
    <div class="row mb-5">
      <div class="col-md-12 mt-3">
        <label>Nombre</label>
        <input
          class="form-control"
          v-model="name"
          :disabled="isSaving"
        >
      </div>
      <div
        v-if="error"
        class="col-md-12 mt-2"
      >
        <div class="text-danger">
          {{ error }}
        </div>
      </div>
      <div class="col-md-12 mt-3">
        <div style="float: right">
          <vs-button
            class="action"
            color="primary"
            type="border"
            icon="save"
            :disabled="isSaving"
            @click="handleSave"
          >
            Guardar
          </vs-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { saveFolder } from '@/febos/global/empresas/servicios/configParams.service';

export default {
  name: 'FolderModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    folder: {
      type: Object,
      default: null
    },
    parentId: {
      type: String,
      default: null
    },
    childrenCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      name: '',
      isSaving: false,
      error: null
    };
  },
  computed: {
    isEdit() {
      return !!(this.folder && this.folder.optionId);
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.name = this.isEdit ? this.folder.name : '';
        this.error = null;
      }
    }
  },
  methods: {
    async handleSave() {
      this.isSaving = true;
      this.error = null;
      try {
        const data = this.isEdit
          ? {
            optionId: this.folder.optionId,
            parameterId: this.folder.parameterId,
            name: this.name
          }
          : {
            name: this.name,
            parentId: this.parentId,
            order: this.childrenCount
          };
        await saveFolder(data);
        this.$emit('save');
        this.$emit('close');
      } catch (err) {
        this.error = err.message;
      } finally {
        this.isSaving = false;
      }
    }
  }
};
</script>
